import type { ICameraModifier, IPointerAction, IPointerActionFactory } from '../PointerHandlerAdjustCamera';
import { TouchPointerAction } from './TouchPointerAction';
import { MousePointerAction } from './MousePointerAction';
import type { PointerSyntheticEvent } from '../PointerSyntheticEvent';
import type { IPointerController } from '../PointerController';
import type { IRaycaster } from '@/engine/app/interfaces';

export class PointerActionFactory implements IPointerActionFactory {
  private readonly _rayCaster: IRaycaster;

  public constructor(rayCaster: IRaycaster) {
    this._rayCaster = rayCaster;
  }

  public createPointerAction(
    event: PointerSyntheticEvent,
    pointerController: IPointerController,
    cameraModifier: ICameraModifier,
    noRotate: boolean,
    rotateAroundCenterZoom: number
  ): IPointerAction {
    if (event.originalEvent.pointerType === 'touch') {
      return new TouchPointerAction(this._rayCaster, cameraModifier, noRotate, rotateAroundCenterZoom);
    }
    return new MousePointerAction(this._rayCaster, cameraModifier, pointerController, noRotate, rotateAroundCenterZoom);
  }
}
